import { DropzoneInputProps, DropzoneRootProps } from 'react-dropzone';
import { MdOutlineTextSnippet } from 'react-icons/md';

export type ButtonProps = {
  getRootProps: <T extends DropzoneRootProps>(props?: T) => T;
  getInputProps: <T extends DropzoneInputProps>(props?: T) => T;
  placeholder: string;
  isInvalid: boolean;
};

export const RegularButton = ({ getRootProps, getInputProps, placeholder, isInvalid }: ButtonProps) => {
  return (
    <div
      {...getRootProps({
        className: `dropzone w-20 h-6 border hover:bg-base-55
               flex items-center justify-center rounded-xl cursor-pointer ${isInvalid ? 'border-danger' : 'border-base-5'}`,
      })}
    >
      <input {...getInputProps()} />
      <p className={`${isInvalid ? 'text-danger' : 'text-base-5'} text-xs-sb`}>{`+ ${placeholder}`}</p>
    </div>
  );
};

export const DashedButton = ({ getRootProps, getInputProps, placeholder, isInvalid }: ButtonProps) => {
  return (
    <div
      {...getRootProps({
        className: `dropzone px-3 h-9 border border-1.5 border-dashed
               flex items-center justify-center gap-1.5 shrink-0 rounded-full cursor-pointer ${isInvalid ? 'border-danger' : 'border-base-20'}`,
      })}
    >
      <input {...getInputProps()} />
      <MdOutlineTextSnippet size={20} className="text-base-20" />
      <p className={`${isInvalid ? 'text-danger' : 'text-base-20'} text-l-sb`}>{placeholder}</p>
    </div>
  );
};
